export default __webpack_public_path__ + "static/media/tony.0f574a83.svg";